import Footer2 from 'components/layouts/Footer2';
import LayoutHeader from 'components/layouts/LayoutHeader';
import LayoutBasics from 'components/layouts/LayoutBasics';
import LayoutNavbar from 'components/layouts/LayoutNavbar';

import { connect } from 'react-redux';

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

const PageBasics = ({ auth: { isAuthenticated, loading } }) => {
    return (
        <>
            <LayoutNavbar />
            {!isAuthenticated && <LayoutHeader />}
            <LayoutBasics />
            <Footer2 isBody={true} isBottomBar={true} />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps)(PageBasics);
